module.exports = __webpack_public_path__ + "static/microphone-1-207b164af62b89b5464161f70ae31905.jpg";